import { HttpClient } from '@angular/common/http';
import { Injectable, ViewChild } from '@angular/core';
import { Events, PopoverController, Nav } from 'ionic-angular';
import { AppState } from '../../config/state';
import { CoCountdownComponent } from '../../components/co-countdown/co-countdown';
/*
  Generated class for the TimeoutProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TimeoutProvider {
  @ViewChild(Nav) nav: Nav;
  timeoutInterval: number;
  timeoutWarning: number;
  forceTimeout: boolean = false;
  inactivePopover: any = false;
  resetFunction: any;
  timeoutID: any;
  timeoutWarningID: any;
  savecfg: any;
  constructor(private http: HttpClient, private events : Events, private popoverCtrl : PopoverController, private state : AppState) {
  }

  public initializeTimeout(timeout, cfg, warning?){
    this.savecfg = cfg;
    this.timeoutInterval = timeout;
    this.timeoutWarning = warning || 15000;
    //   this.timeoutWarning = 10000;  //USE FOR TESTING TIMEOUT WARNING
    //   this.timeoutInterval = 20000; //USE THIS FOR TESTING TIMEOUT = 20 SECONDS
      // this.events.subscribe('changeTimeoutTiming', (force?)=>{
      //   this.forceTimeout = force || false;
      //   this.timeoutInterval = this.state.novelistTimeoutNumber;
      //   this.timeoutWarning = 0;
      //   this.resetFunction();
      // });
      // this.events.subscribe('resetTimeoutTiming', ()=>{
      //   this.forceTimeout = false;
      //   this.timeoutInterval = this.savecfg.timeoutInterval;
      //   this.timeoutWarning = this.savecfg.settings.timeoutWarning || 15000;
      //   this.resetFunction();
      // });
      let self = this;
      this.resetFunction = function () {
        window.clearTimeout(self.timeoutID);
        window.clearTimeout(self.timeoutWarningID);
        if (self.inactivePopover){
          self.inactivePopover.dismiss().catch(err=>{});
        }
        self.inactivePopover = false;
        self.startTimeout();
      }
	  console.info(`Setting inactivity timer to ${this.timeoutInterval} milliseconds, warning at ${this.timeoutWarning}`);
      document.addEventListener("mousemove", this.resetFunction, false);
      document.addEventListener("mousedown", this.resetFunction, false);
      document.addEventListener("keypress", this.resetFunction, false);
      document.addEventListener("DOMMouseScroll", this.resetFunction, false);
      document.addEventListener("mousewheel", this.resetFunction, false);
      document.addEventListener("touchmove", this.resetFunction, false);
      document.addEventListener("MSPointerMove", this.resetFunction, false);
      this.startTimeout();
  }

  public changeTimeout(time, force?, warning?){
    this.timeoutInterval = time;
    this.timeoutWarning = warning;
    this.forceTimeout = force || false;
    console.info(`Setting inactivity timer to ${this.timeoutInterval} milliseconds, warning at ${this.timeoutWarning}`);
    this.resetFunction();
  }

  public resetTimeout(){
    this.timeoutInterval = this.savecfg.timeoutInterval;
    this.timeoutWarning = this.savecfg.settings.timeoutWarning || 15000;
    console.info(`Resetting inactivity timer to ${this.timeoutInterval} milliseconds, warning at ${this.timeoutWarning}`);
    this.resetFunction();
  }

 public startTimeout() {

	this.timeoutWarningID = window.setTimeout(()=>{ // inactivity warning
		console.log(`Auto logging out warning after ${this.timeoutInterval} milliseconds of inactivity`);
      let message = 'You will be logged out in...';
      let detail = '';
      let buttonLabel = 'Cancel';
      if(!this.state.loggedInPatronId) {
        message = 'Still there?';
        detail = 'Tap anywhere to continue';
        buttonLabel = 'Continue';
      }
      if(this.state.loggedInPatronId || this.forceTimeout) {
        this.inactivePopover = this.popoverCtrl.create(CoCountdownComponent, { time: this.timeoutWarning/1000, message, detail, buttonLabel }, { cssClass: 'place-holds-popover' });
        this.inactivePopover.present();
      }
    }, (this.timeoutInterval - this.timeoutWarning)); //will kick in the Warning's time before Interval's time

    this.timeoutID = window.setTimeout(() => {
      console.log(`Auto logging out patron after ${this.timeoutInterval} milliseconds of inactivity`);
      this.events.publish('closeKeyboard');
      this.events.publish('login:dismiss');
      if(this.state.loggedInPatronId || this.forceTimeout){
        this.events.publish('timeoutCalled');
        this.forceTimeout = false;
        this.state.nav.popToRoot();
      };
    }, this.timeoutInterval);

  }
}



// WEBPACK FOOTER //
// ./src/providers/timeout/timeout.ts